// src/services/api/operator.js
import axiosInstance from "@/services/api/instance";
import store from "@/store";

const space = () => store.getters["global/getSpace"];

/**
 * Build query string: accepts string ("a=1&b=2") OR plain object ({ a:1, b:2, tags:['x','y'] })
 * Multi-value filters are sent as a single comma-separated param (tag_uuid=a,b), not repeated keys.
 */
function withQS(base, qs) {
  if (!qs) return base;
  if (typeof qs === "string") return `${base}?${qs}`;

  const parts = Object.entries(qs)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .filter(([, v]) => !Array.isArray(v) || v.length)
    .map(([k, v]) =>
      Array.isArray(v)
        ? `${encodeURIComponent(k)}=${v.map((x) => encodeURIComponent(x)).join(",")}`
        : `${encodeURIComponent(k)}=${encodeURIComponent(v)}`
    );

  return parts.length ? `${base}?${parts.join("&")}` : base;
}

export default {
  /* =========================
   * OPERATORS
   * ======================= */

  // GET /space/{space_uuid}/operator/items/
  getOperators(qs) {
    return axiosInstance.get(withQS(`/space/${space()}/operator/items/`, qs));
  },

  // POST /space/{space_uuid}/operator/add/
  // payload shape prema tvojem primjeru
  addOperator(payload) {
    return axiosInstance.post(`/space/${space()}/operator/add/`, payload);
  },

  // GET /space/{space_uuid}/operator/{operator_uuid}/
  getOperator(operator_uuid) {
    return axiosInstance.get(`/space/${space()}/operator/${operator_uuid}/`);
  },

  // PATCH /space/{space_uuid}/operator/{operator_uuid}/
  updateOperator(operator_uuid, payload) {
    return axiosInstance.patch(`/space/${space()}/operator/${operator_uuid}/`, payload);
  },

  // PATCH /space/{space_uuid}/operator/{operator_uuid}/reset-credentials/
  resetOperatorCredentials(operator_uuid, payload) {
    return axiosInstance.patch(
      `/space/${space()}/operator/${operator_uuid}/reset-credentials/`,
      payload
    );
  },

  // PATCH /space/{space_uuid}/operator/{operator_uuid}/keycloak-account-update/
  updateOperatorKeycloakAccount(operator_uuid, keycloak_account_id) {
    return axiosInstance.patch(
      `/space/${space()}/operator/${operator_uuid}/keycloak-account-update/`,
      { keycloak_account_id }
    );
  },

  /* =========================
   * DELETE OPERATIONS
   * ======================= */

  // DELETE /space/{space_uuid}/operator/{operator_uuid}/
  deleteOperator(operator_uuid) {
    return axiosInstance.delete(`/space/${space()}/operator/${operator_uuid}/`);
  },

  // DELETE /space/{space_uuid}/operator-group/{operator_group_uuid}/
  deleteOperatorGroup(operator_group_uuid) {
    return axiosInstance.delete(`/space/${space()}/operator-group/${operator_group_uuid}/`);
  },

  /* =========================
   * OPERATOR GROUPS
   * ======================= */

  // GET /space/{space_uuid}/operator-group/items/
  getOperatorGroups(qs) {
    return axiosInstance.get(withQS(`/space/${space()}/operator-group/items/`, qs));
  },

  // POST /space/{space_uuid}/operator-group/add/
  addOperatorGroup(payload) {
    return axiosInstance.post(`/space/${space()}/operator-group/add/`, payload);
  },

  // GET /space/{space_uuid}/operator-group/{operator_group_uuid}/
  getOperatorGroup(operator_group_uuid) {
    return axiosInstance.get(
      `/space/${space()}/operator-group/${operator_group_uuid}/`
    );
  },

  // PATCH /space/{space_uuid}/operator-group/{operator_group_uuid}/
  updateOperatorGroup(operator_group_uuid, payload) {
    return axiosInstance.patch(
      `/space/${space()}/operator-group/${operator_group_uuid}/`,
      payload
    );
  },

  /* ===== Membership (operators in a group) ===== */

  // GET /space/{space_uuid}/operator-group/{operator_group_uuid}/operator/items/
  getOperatorsInGroup(operator_group_uuid, qs) {
    return axiosInstance.get(
      withQS(
        `/space/${space()}/operator-group/${operator_group_uuid}/operator/items/`,
        qs
      )
    );
  },

  // POST /space/{space_uuid}/operator-group/{operator_group_uuid}/operator/add/
  // payload: { "created_by_email": "string", "operator_uuids": ["uuid1", "uuid2"], "space_operators": [ { ... } ] }
  addOperatorsToGroup(operator_group_uuid, payload) {
    return axiosInstance.post(
      `/space/${space()}/operator-group/${operator_group_uuid}/operator/add/`,
      payload
    );
  },

  // DELETE /space/{space_uuid}/operator-group/{operator_group_uuid}/operator/{operator_uuid}/
  removeOperatorFromGroup(operator_group_uuid, operator_uuid) {
    return axiosInstance.delete(
      `/space/${space()}/operator-group/${operator_group_uuid}/operator/${operator_uuid}/`
    );
  },

  /* =========================
   * CUSTOM FIELDS (space scope)
   * ======================= */

  // PATCH /space/{space_uuid}/operator-custom-fields/
  patchOperatorCustomFields(payload) {
    return axiosInstance.patch(
      `/space/${space()}/operator-custom-fields/`,
      payload
    );
  },
  permissionsCategoryGroupClaim() {
    return axiosInstance.get(
      `/operator/permission-category-group-claim/items/`
    );
  },

  // Permissions API
  getPermissions() {
    return axiosInstance.get('/operator/permission-category-group-claim/items/');
  }
};
